<template>
  <layout-main-inner
    title="订单统计"
    class="stat-inventory">
    <div slot="action">
      <dept-select
        v-model="query.departmentId"
        style="width: 150px;margin-right: 10px"
        :callback="()=>fetch()" />
      <order-source-select
        v-model="query.orderSource"
        style="width: 150px;margin-right: 10px"
        :callback="()=>fetch()" />
      <el-date-picker
        v-model="query.month"
        style="width: 235px"
        type="monthrange"
        unlink-panels
        placeholder="选择月"
        format="yyyy 年 MM 月"
        :clearable="false"
        :editable="false"
        @change="fetch">
      </el-date-picker>
      <el-button
        style="margin-left: 10px"
        type="primary"
        @click="fetch">查询</el-button>
    </div>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">本期数据</template>
      <el-row>
        <el-col :span="24">
          <summary-list
            :span="6"
            :list="summaryList" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="24">
          <v-title title="本期产品销售金额情况" />
          <order-sku-chart :series="stock" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="24">
          <v-title title="本期订单销售金额情况" />
          <order-cus-chart :series="stock1" />
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import moment from 'moment'
import SummaryList from './busi/summary.vue'

import VTitle from './v-title.vue'

import OrderSourceSelect from '../orders/order-source-select.vue'
import DeptSelect from './order/dept-select.vue'
import OrderSkuChart from './order/order-sku-chart.vue'
import OrderCusChart from './order/order-cus-chart.vue'
export default {
  name: 'StatOrder',
  components: { SummaryList, OrderSkuChart, OrderCusChart, OrderSourceSelect, DeptSelect, VTitle },
  data() {
    const start = +moment().subtract(5, 'month')
    const end = +moment()
    return {
      loading: false,
      query: {
        month: [start, end],
        departmentId: null,
        orderSource: null
      },
      summaryList: [
        {
          label: '平均客单价',
          value: 0
        },
        {
          label: '平均货单价',
          value: 0
        },
        {
          label: '销售金额',
          value: 0
        },
        {
          label: '销售订单数',
          value: 0
        }
      ],
      stock: {
        xAxis: [],
        s1: [],
        s2: [],
        s3: []
      },
      stock1: {
        xAxis: [],
        s1: [],
        s2: [],
        s3: []
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true
      const [beginDate, endDate] = this.query.month
      const { departmentId, orderSource } = this.query
      this.$store.dispatch('stat/sumordertrend', {
        payload: {
          beginPeriod: moment(beginDate).format('YYYYMM'),
          endPeriod: moment(endDate).format('YYYYMM'),
          departmentId, orderSource
        },
        success: (res) => {
          this.loading = false
          console.log(res)
          this.$set(this, 'summaryList', [
            {
              label: '平均客单价',
              value: res.data.averageCustomerAmount
            },
            {
              label: '平均货单价',
              value: res.data.averageProductAmount
            },
            {
              label: '销售金额',
              value: res.data.totalAmount
            },
            {
              label: '销售订单数',
              value: res.data.totalOrderCount
            }
          ])
          this.formatData(res.data.periodOrders)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    formatData(detail) {
      const xAxis = []
      const s11 = []
      const s12 = []
      const s21 = []
      const s22 = []
      const s3 = []
      detail.forEach(i => {
        const { averageCustomerAmount, averageProductAmount, statPeriod, totalAmount, totalOrderCount, totalProductCount } = i
        xAxis.push(moment(statPeriod, 'YYYYMM').format('YYYY年MM月'))
        s11.push(averageCustomerAmount)
        s21.push(averageProductAmount)
        s3.push(totalAmount)
        s12.push(totalOrderCount)
        s22.push(totalProductCount)
      })
      this.$set(this, 'stock', {
        xAxis, s1: s21, s2: s3, s3: s22
      })
      this.$set(this, 'stock1', {
        xAxis, s1: s11, s2: s3, s3: s12
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
    .grid-content {
        height 300px;
    }
</style>
